import React, { useState } from 'react';
import Sheet from '../../../../ui/Sheet.jsx';
import Button from '../../../../ui/Button.jsx';
import WidgetShell from '../../../../ui/WidgetShell.jsx';
import { SmallText, SectionTitle } from '../../../../ui/Typography.jsx';
import { generateProductionTasks } from '../../logic/productionEngine';

export default function GeneratePlanSheet({ open, onClose, onSubmit, products = [] }) {
  const today = new Date().toISOString().slice(0, 10);
  const [startDate, setStartDate] = useState(today);
  const [productId, setProductId] = useState(products[0]?.id || '');
  const selectedProduct = products.find(p => p.id === productId) || products[0] || { id: '', name: '' };
  const fieldClasses = "rounded-md border px-2 py-1 bg-[var(--mudo-bg)] text-[var(--mudo-text)] border-[var(--mudo-border)] focus:outline-none focus:ring-2 focus:ring-[var(--mudo-primary)] focus:border-[var(--mudo-primary)] placeholder:text-[var(--mudo-text-muted)]";

  const handleGenerate = () => {
    const tasks = generateProductionTasks({ startDate, product: selectedProduct });
    onSubmit?.(tasks);
    onClose?.();
  };

  return (
    <Sheet open={open} onClose={onClose} title="Generate Production Plan">
      <div className="flex flex-col gap-4">
        <WidgetShell title="Inputs">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <label className="flex flex-col">
              <SmallText className="mb-1">Start Date</SmallText>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className={fieldClasses}
              />
            </label>
            <label className="flex flex-col">
              <SmallText className="mb-1">Product</SmallText>
              <select
                value={productId}
                onChange={(e) => setProductId(e.target.value)}
                className={fieldClasses}
              >
                {products.map((p) => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
            </label>
          </div>
        </WidgetShell>

        <WidgetShell title="Preview">
          <SectionTitle className="mb-2">Stages</SectionTitle>
          <ul className="list-disc pl-5">
            {generateProductionTasks({ startDate, product: selectedProduct }).map((t) => (
              <li key={t.id}>
                <SmallText>
                  {t.title} — {new Date(t.startDate).toLocaleDateString()} → {new Date(t.dueDate).toLocaleDateString()}
                </SmallText>
              </li>
            ))}
          </ul>
        </WidgetShell>

        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button variant="primary" onClick={handleGenerate}>Create Tasks</Button>
        </div>
      </div>
    </Sheet>
  );
}
